export default {
	"70046c271624aceefdf18048e78721d9": "The price of the product has changed. Please contact customer service to provide a new order link",
	"405381ab0d95a7fd1506e03f331e6c09": "I see.",
	"9b04c6f904c8c575d43aeb92719a1fbc": "Contact customer service"
}
